module.exports = __webpack_public_path__ + "images/DEV_THUMBNAIL_05-78ff8e00710541c61eaea3094da8b8fe.jpg";